module.exports = __webpack_public_path__ + "static/media/purple-product-list-icon.7ae8001e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/purple-product-list-icon.svg
// module id = 2252
// module chunks = 0